/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentMetricDatapointDto } from './DeploymentMetricDatapointDto';
import {
    DeploymentMetricDatapointDtoFromJSON,
    DeploymentMetricDatapointDtoFromJSONTyped,
    DeploymentMetricDatapointDtoToJSON,
} from './DeploymentMetricDatapointDto';
import type { DeploymentMetricSummaryDto } from './DeploymentMetricSummaryDto';
import {
    DeploymentMetricSummaryDtoFromJSON,
    DeploymentMetricSummaryDtoFromJSONTyped,
    DeploymentMetricSummaryDtoToJSON,
} from './DeploymentMetricSummaryDto';

/**
 * 
 * @export
 * @interface DeploymentMetricSeriesDto
 */
export interface DeploymentMetricSeriesDto {
    /**
     * The key of the metric from the definition.
     * @type {string}
     * @memberof DeploymentMetricSeriesDto
     */
    key: string;
    /**
     * The display label of the metric.
     * @type {string}
     * @memberof DeploymentMetricSeriesDto
     */
    label: string;
    /**
     * The unit of the metric.
     * @type {string}
     * @memberof DeploymentMetricSeriesDto
     */
    unit: string | null;
    /**
     * How the metric should be displayed.
     * @type {string}
     * @memberof DeploymentMetricSeriesDto
     */
    chart: DeploymentMetricSeriesDtoChartEnum;
    /**
     * The summaries that are shown as cards in the UI.
     * @type {Array<DeploymentMetricSummaryDto>}
     * @memberof DeploymentMetricSeriesDto
     */
    summaries: Array<DeploymentMetricSummaryDto>;
    /**
     * The collected datapoints, ordered by timestamp.
     * @type {Array<DeploymentMetricDatapointDto>}
     * @memberof DeploymentMetricSeriesDto
     */
    datapoints: Array<DeploymentMetricDatapointDto>;
}


/**
 * @export
 */
export const DeploymentMetricSeriesDtoChartEnum = {
    Line: 'line',
    Bar: 'bar'
} as const;
export type DeploymentMetricSeriesDtoChartEnum = typeof DeploymentMetricSeriesDtoChartEnum[keyof typeof DeploymentMetricSeriesDtoChartEnum];


/**
 * Check if a given object implements the DeploymentMetricSeriesDto interface.
 */
export function instanceOfDeploymentMetricSeriesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "unit" in value;
    isInstance = isInstance && "chart" in value;
    isInstance = isInstance && "summaries" in value;
    isInstance = isInstance && "datapoints" in value;

    return isInstance;
}

export function DeploymentMetricSeriesDtoFromJSON(json: any): DeploymentMetricSeriesDto {
    return DeploymentMetricSeriesDtoFromJSONTyped(json, false);
}

export function DeploymentMetricSeriesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentMetricSeriesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'unit': json['unit'],
        'chart': json['chart'],
        'summaries': ((json['summaries'] as Array<any>).map(DeploymentMetricSummaryDtoFromJSON)),
        'datapoints': ((json['datapoints'] as Array<any>).map(DeploymentMetricDatapointDtoFromJSON)),
    };
}

export function DeploymentMetricSeriesDtoToJSON(value?: DeploymentMetricSeriesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'label': value.label,
        'unit': value.unit,
        'chart': value.chart,
        'summaries': ((value.summaries as Array<any>).map(DeploymentMetricSummaryDtoToJSON)),
        'datapoints': ((value.datapoints as Array<any>).map(DeploymentMetricDatapointDtoToJSON)),
    };
}

